export const passwordValidationRules = [
  [(value) => value.length >= 8 && value.length <= 20, 'PASSWORD_VALIDATION.LENGTH_RULE'],
  [(value) => value.toUpperCase() !== value, 'PASSWORD_VALIDATION.LOWERCASE_LETTER_RULE'],
  [(value) => value.toLowerCase() !== value, 'PASSWORD_VALIDATION.UPPERCASE_LETTER_RULE'],
  [(value) => /\d/.test(value), 'PASSWORD_VALIDATION.NUMBER_RULE'],
  [(value) => /[!?@#$%^&*)(+=,.<>{}[\]:;'"|~`_\-\\/]/g.test(value), 'PASSWORD_VALIDATION.SPECIAL_CHARACTER_RULE']
];
